import WhatsApp from './whatsApp'

export default WhatsApp